import React, { useState, useEffect } from 'react';
import './Payment.css';
import { useStateValue } from './StateProvider';
import { Link, useHistory } from 'react-router-dom';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import CurrencyFormat from 'react-currency-format';
import axios from './axios';
import { db } from './firebase';

// Components
import CheckoutProduct from './CheckoutProduct';


function Payment() {
    const [{ basket, user }, dispatch] = useStateValue();
    const history = useHistory();

    const stripe = useStripe();
    const elements = useElements();

    const [error, setError] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState("");
    const [clientSecret, setClientSecret] = useState(true);
    const [razorpayResponse, setRazorpayResponse] = useState({});

    useEffect(() => {
        // generate the special stripe secret which allows us to charge a 
        // customer

        // const getClientSecret = async () => {
        //     const response = await axios({
        //         method: 'post',
        //         // Stripe expects the total in a currency's subunits
        //         url: `/payments/create?total=${getBasketTotal(basket) * 100}`
        //     });
        //     setClientSecret(response.data.clientSecret);
        // }

        const getRazorOrderId = async () => {
            const response = await axios({
                method: 'get',
                url: `/razorpay_orders?total=${getBasketTotal(basket) * 100}`
            });
            setRazorpayResponse(response);
        }

        getRazorOrderId();
        // getClientSecret();
    }, [basket])

    const paymentHandler = async event => {
        event.preventDefault();

        setProcessing(true);

        const options = {
            key: "rzp_test_FXwuvFm1zrHM2e",
            name: "React and Firebase Amazon Clone",
            description: "Amazon Clone Payments with Razorpay",
            order_id: razorpayResponse.data.id,
            handler: async (response) => {
              try {
                db.collection('users')
                .doc(user?.uid)
                .collection('orders')
                .doc(response.razorpay_order_id)
                .set({
                    basket: basket,
                    amount: razorpayResponse.data.amount,
                    created: razorpayResponse.data.created_at
                })

                setSucceeded(true);
                setError(null);
                setProcessing(false);

                dispatch({
                    type: 'EMPTY_BASKET'
                });

                history.replace('/orders');
              } catch (err) {
                console.log(err);
              }
            }
        }

        const rzp1 = new window.Razorpay(options);
        rzp1.open();
    }

    const handleSubmit = async event => {
        event.preventDefault();

        setProcessing(true);

        const payload = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement)
            }
        }).then(({ paymentIntent }) => {
            // paymentIntent = payment confirmation

            db.collection('users')
              .doc(user?.uid)
              .collection('orders')
              .doc(paymentIntent.id)
              .set({
                  basket: basket,
                  amount: paymentIntent.amount,
                  created: paymentIntent.created
              })

            setSucceeded(true);
            setError(null);
            setProcessing(false);

            dispatch({
                type: 'EMPTY_BASKET'
            });

            history.replace('/orders');
        });
    }

    const handleChange = event => {
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "")
    }

    const getBasketTotal = basket => 
        basket.reduce((amount, item) => item.price + amount, 0);

    return (
        <div className="payment">
            <div className="payment__container">
                <h1>
                    Checkout (
                        <Link to="/checkout">{basket?.length} items</Link>
                    )
                </h1>
                <div className="payment__section">
                    <div className="payment__title">
                        <h3>Shipping Address</h3>
                    </div>
                    <div className="payment__address">
                        <p>{user?.email.split('@')[0]}</p>
                        <p>Delhi Technological University</p>
                        <p>Bawana Road, New Delhi - 110042</p>
                    </div>
                </div>

                <div className="payment__section">
                    <div className="payment__title">
                        <h3>Review Items and Delivery</h3>
                    </div>
                    <div className="payment__items">
                        {basket.map(item => {
                            return <CheckoutProduct product={item} />
                        })}
                    </div>
                </div>

                <div className="payment__section">
                    <div className="payment__title">
                        <h3>Payment Method</h3>
                    </div>
                    <div className="payment__details">
                        <form onSubmit={paymentHandler}>
                            {/* <CardElement onChange={handleChange} /> */}
                            <div className="payment__priceContainer">
                                <CurrencyFormat
                                    renderText={value => (
                                        <>
                                            <h3>Order Total: {value}</h3>
                                        </>
                                    )}
                                    decimalScale={2}
                                    value={getBasketTotal(basket)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    thousandSpacing={'2s'}
                                    prefic={"₹"}
                                />
                                <button>
                                    <span>
                                        {processing ? <p>Processing</p> : "Place Order"}                     
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Payment;
